module.exports = __webpack_public_path__ + "static/media/employee.855a0a39.png";